import { TransProps, useTranslation } from 'react-i18next';

import { AppLanguage } from '../enums';

export const useAppLanguage: () => AppLanguage = (): AppLanguage => {
  const { i18n }: TransProps<never> = useTranslation();

  const isAppLanguage: (value: string) => value is AppLanguage = (value: string): value is AppLanguage =>
    Object.values<string>(AppLanguage).includes(value);

  return isAppLanguage(i18n.language) ? i18n.language : AppLanguage.Pl;
};
